import React from 'react';

import { Content } from 'LegacySBCRA/Content/Content';

import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import { RoundedSection } from '../../../common/RoundedSection/RoundedSection';
import type { SimpleHeroBlock } from '../../@types/landingPages';
import { landingPageSectionLoadEvent, PAGE_SECTIONS } from '../../Pages/LandingPage.helpers';

import styles from './SimpleHero.scss';

type Props = Omit<SimpleHeroBlock, 'acf_fc_layout' | 'theme'>;

export const SimpleHero = ({ heading_one: h1, subtitle }: Props) => {
  const { setRef } = usePageRefEvents({
    onRefTrigger: () => landingPageSectionLoadEvent(PAGE_SECTIONS.HERO),
  });

  return (
    <RoundedSection withBottomLedge theme="primary-yellow">
      <Content
        center
        className={styles.hero}
      >
        <div ref={(ref) => setRef(ref)}>
          <h1 className={styles.title}>{h1}</h1>
          {subtitle && <p data-thc-style-override className={styles.subtitle}>{subtitle}</p>}
        </div>
      </Content>
    </RoundedSection>
  );
};
